import React from 'react';

import { PortfolioLayout } from 'features/pages/portfolio/Portfolio/PortfolioLayout';

import { FileIngestOperationProvider } from './FileIngestOperation';
import TapeUploadContext from './loanTapeUploader/TapeUploadContext';
import { MapFieldsOperationProvider } from './MapFieldsOperation';
import { TapeUploadFlow } from './TapeUploadFlow';

export const TapeUploadPage: React.FC = () => {
  return (
    <PortfolioLayout hideSummery={true}>
      <TapeUploadContext.Provider
        value={{
          uploadedTapes: [],
          selectedFile: undefined,
          selectedFileId: undefined,
          setSelectedFileId: () => {
            throw new Error('setSelectedFileId not implemented');
          },
        }}
      >
        <FileIngestOperationProvider>
          <MapFieldsOperationProvider>
            <TapeUploadFlow />
          </MapFieldsOperationProvider>
        </FileIngestOperationProvider>
      </TapeUploadContext.Provider>
    </PortfolioLayout>
  );
};
